<template>
  <div style="position: fixed; bottom: 5px; width: 400px; left: calc(50% - 200px); z-index: 6000;" v-if="event__type">
    <v-alert
        rounded="xl"
        density="compact"
        style="background: white"
        color="amber"
        variant="outlined"
        prominent
        border="top"
        class="ma-1"
    >
      <template v-slot:title>
        ТЕКУЩЕЕ ДЕЙСТВИЕ
      </template>
      <template v-slot:text>
        {{ name }} <span v-if="event__data.number"> - {{ event__data.number }}</span>
      </template>
      <template v-slot:prepend>
        <v-icon :icon="['fas', icon]" />
      </template>
    </v-alert>
  </div>
</template>

<script>
import { CurrentElement, CurrentElement__Data, CurrentElement__Dst } from "@/store/wp_planner/events.store";

export default {
  name: "CurrentEvent__WP_Alert",
  computed: {
    icon() {
      switch (this.event__type) {
        case 'document': return 'file'
        case 'specialist'  : return 'user'
        default        : return null
      }
    },
    name() {
      switch (this.event__type) {
        case 'document': return 'ДОКУМЕНТ'
        case 'specialist'  : return 'СПЕЦИАЛИСТ'
      }
      return null
    },
    event__dst: {
      get() {
        return CurrentElement__Dst().get()
      },
      set(value) {
        CurrentElement__Dst().set(value)
      }
    },
    event__data: {
      get() {
        return CurrentElement__Data().get()
      },
      set(value) {
        CurrentElement__Data().set(value)
      }
    },
    event__type: {
      get() {
        return CurrentElement().get()
      },
      set(value) {
        CurrentElement().set(value)
      }
    },
  }
}
</script>

<style scoped>

</style>
